import { EmployeeGroup } from "@/Common/Api/Employee/Dto/EmployeeGroup";

interface IGroupsSearchAutocompleteProps {
    onItemSelectCallback: (group: EmployeeGroup) => void;
    groups: Immutable.List<EmployeeGroup>;
    focusOnMount?: boolean;
    searchOnMount?: boolean;
    componentId: string;
    text: string;
    // textChangedFunction?: (s: string) => void;
    isValid?: boolean;
    debounceOnTextChangeMS?: number;
}
class GroupsSearchAutocompleteState {
    public searchGroups: EmployeeGroup[];
    public isListDisplayed: boolean;
    public text: string;
}

class GroupsSearchAutocomplete extends React.Component<IGroupsSearchAutocompleteProps, GroupsSearchAutocompleteState> {
    private timeoutReferenceGroup: number;
    private timeoutReferenceBlur: number;

    constructor(props: IGroupsSearchAutocompleteProps) {
        super(props);

        this.timeoutReferenceGroup = -1;
        this.timeoutReferenceBlur = -1;

        const initialState = new GroupsSearchAutocompleteState();
        initialState.searchGroups = [];
        initialState.text = this.props.text;
        initialState.isListDisplayed = false;
        this.state = initialState;
    }

    public componentDidUpdate(prevProps: IGroupsSearchAutocompleteProps): void {
        if (prevProps.text != this.props.text) {
            this.mutateState(s => {
                s.text = this.props.text;
                s.isListDisplayed = false;
                s.searchGroups = [];
            });
        }
    }

    public componentDidMount(): void {
        var self = this;

        if (this.props.focusOnMount == true) {
            window.setTimeout(() => $("#" + self.props.componentId).focus(), 500);
        }

        if (this.props.searchOnMount == true && this.props.text != "") {
            this.TrottledExecuteSearch(0);
        }
    }

    public render(): JSX.Element {
        var errorClass = this.props.isValid ? "" : " has-error";

        return (
            <div id={"Parentdiv_" + this.props.componentId} className={"group-autocomplete" + errorClass}>
                <input
                    id={this.props.componentId}
                    key={this.props.componentId}
                    type="text"
                    className="form-control"
                    style={{ "width": "100%" }}
                    onBlur={() => this.onBlur()}
                    onFocus={() => this.onFocus()}
                    onClick={() => this.TrottledExecuteSearch()}
                    onChange={e => this.onTextChange(e)}
                    value={this.state.text}
                    onKeyDown={e => this.onKeyDown(e)}
                />
                {this.state.isListDisplayed != false && (
                    <div className="group-results-ps">
                        <div id="scroll_container" className="group-results-container" style={{ "overflowX": "hidden" }}>
                            <ul className="group-result-list">
                                {this.state.searchGroups.map((x: EmployeeGroup, i: number) => {
                                    let cssStyle: React.CSSProperties = {};
                                    if (x.IsHighlighted == true)
                                        cssStyle = { backgroundColor: "#e4edfb" };

                                    return (
                                        <li id={"li_group_" + i} key={"li_group_" + i} onClick={() => this.selectItem(x)}>
                                            <div id={"group_" + i} key={"group_" + i} className="group-result" style={cssStyle}>
                                                <h5>{x.Name}</h5>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                )}
                {(this.state.isListDisplayed && this.state.searchGroups && this.state.searchGroups.length == 0) && (
                    <div className="group-results-ps">
                        <div id="scroll_container" className="group-results-container" style={{ "overflowX": "hidden" }}>
                            <ul className="group-result-list">
                                <li id="li_group__empty" key="li_group__empty">
                                    <div id="group__empty" key="group__empty" className="group-result">
                                        <h5>{cacheStore.GetString("ListEmptyLabel")}</h5>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    private mutateState(mutation: (s: GroupsSearchAutocompleteState) => void, then: () => void = null): void {
        var group = new GroupsSearchAutocompleteState();
        mutation(group);
        if (then != null)
            this.setState(group, then);
        else
            this.setState(group);
    }

    private onTextChange(e: React.ChangeEvent<HTMLInputElement>): void {
        var val = e.target.value;
        var s = new GroupsSearchAutocompleteState();
        s.text = val;
        var self = this;

        if (this.timeoutReferenceGroup !== -1) {
            clearTimeout(this.timeoutReferenceGroup);
            this.timeoutReferenceGroup = -1;
        }
        if (this.timeoutReferenceBlur !== -1) {
            clearTimeout(this.timeoutReferenceBlur);
            this.timeoutReferenceBlur = -1;
        }

        this.setState(s, () => {
            self.timeoutReferenceGroup = window.setTimeout(() => {
                self.TrottledExecuteSearch();
            }, 200);
        });
    }

    private selectItem(item: EmployeeGroup): void {
        var self = this;

        var s = new GroupsSearchAutocompleteState();
        s.text = (item == null) ? "" : item.Name;
        s.isListDisplayed = false;

        this.setState(s, () => { self.props.onItemSelectCallback(item); });
    }

    private TrottledExecuteSearch(selectedIndex?: number): void {
        var self = this;
        // Throlle
        if (this.timeoutReferenceGroup !== -1) {
            clearTimeout(this.timeoutReferenceGroup);
            this.timeoutReferenceGroup = -1;
        }
        this.timeoutReferenceGroup = window.setTimeout(() => {
            self.executeSearch(selectedIndex);
        }, 250);
    }

    private executeSearch(selectedIndex?: number): void {
        var s = new GroupsSearchAutocompleteState();
        let groups = this.props.groups;

        if (!IsNullOrWhiteSpace(this.state.text)) {
            groups = groups.toArray().filterSearchAdvanced(this.state.text, (IsMatchingSearchTextFct, item: EmployeeGroup) => {
                item.IsHighlighted = false;
                return IsMatchingSearchTextFct(item.Name);
            }).toImmutable();
        }

        s.searchGroups = groups.toArray();
        if (s.searchGroups.length > 0) {
            if (selectedIndex != null) {
                this.selectItem(groups[selectedIndex]);
            }
            else {
                s.isListDisplayed = true;
            }
        }
        s.isListDisplayed = true;
        this.setState(s);
    }

    private onFocus(): void {
        let self = this;
        //  if (self.state.text != "") {
        if (self.state.searchGroups.length > 0 && !self.state.isListDisplayed) {
            var s = new GroupsSearchAutocompleteState();
            s.isListDisplayed = true;
            self.setState(s);
        }
        //   }
        window.setTimeout(() => $("#" + self.props.componentId).select(), 50);
    }

    public onBlur(): void {
        window.setTimeout(() => {
            let s = new GroupsSearchAutocompleteState();
            s.isListDisplayed = false;
            this.setState(s);
        }, 200);
    }

    private onKeyDown(e: React.KeyboardEvent): void {
        // up
        if (e.keyCode === 38) { e.preventDefault(); this.moveSelectionUpOrDown(true); }

        // down
        if (e.keyCode === 40) { e.preventDefault(); this.moveSelectionUpOrDown(false); }

        // enter
        if (e.keyCode === 13 && !e.shiftKey) { e.preventDefault(); this.selectItem(this.state.searchGroups[this.indexOfSelectedItem()]); }

        if (e.keyCode === 27) {
            var s = new GroupsSearchAutocompleteState();
            s.isListDisplayed = false;
            this.setState(s);
        }
    }

    private moveSelectionUpOrDown(IsDirectionUp: boolean): void {
        let self = this;

        if (self.state.searchGroups == null)
            return;

        let collection = self.state.searchGroups;
        if (collection.length == 0)
            return;

        let idx = self.indexOfSelectedItem();
        if (idx === -1) {
            collection.forEach(x => x.IsHighlighted = false);
            collection[IsDirectionUp ? collection.length - 1 : 0].IsHighlighted = true;
            self.mutateState(s => s.searchGroups = collection, () => self.adjustScroll());
            return;
        }
        // Top or bottom of list
        if ((idx === 0 && IsDirectionUp) || (idx === collection.length - 1 && !IsDirectionUp))
            return;

        collection[idx].IsHighlighted = false;
        idx = idx + (IsDirectionUp ? -1 : 1);

        collection[idx].IsHighlighted = true;
        self.mutateState(s => s.searchGroups = collection, () => self.adjustScroll());
    }

    private indexOfSelectedItem(): number {
        if (this.state.searchGroups == null || this.state.searchGroups.length == 0)
            return -1;

        for (var i = 0; i < this.state.searchGroups.length; i++) {
            var item = this.state.searchGroups[i];
            if (item.IsHighlighted == true) {
                return i;
            }
        }
        return -1;
    }

    private adjustScroll(): void {
        let idx = this.indexOfSelectedItem();

        let scrollParent = $("#scroll_container");
        let liSelected = $("#li_group_" + idx);
        let firstItem = $("#li_group_" + 0);
        if (scrollParent != null && liSelected != null && firstItem != null) {
            let scrollParentHeight = scrollParent.height();
            let CurrentScrollPosition = Math.abs(firstItem.position().top);

            let selectedItemRelativePosition = liSelected.position().top;
            let selectedItemHeight = liSelected.height();

            if (selectedItemRelativePosition < 0) // Item is above scoll position
                scrollParent.scrollTop(CurrentScrollPosition + selectedItemRelativePosition);
            else if (selectedItemRelativePosition + selectedItemHeight > scrollParentHeight) // Item is below scroll
                scrollParent.scrollTop(CurrentScrollPosition + (selectedItemRelativePosition + selectedItemHeight - scrollParentHeight)); // Add the offset to scroll position in order to fully include the last item
        }
    }
}

export { GroupsSearchAutocomplete };
